import { ITableConfig, TableColumnType, UITableColumnCellType } from '@shared/ui';

export const operatorTableConfig: ITableConfig = {
  paginationType: 'none',
  columns: [
    {
      type: TableColumnType.Order,
      width: '70px',
    },
    {
      title: 'Название',
      name: {
        type: UITableColumnCellType.Text,
        fieldName: 'operator.title',
      },
      type: TableColumnType.Basic,
    },
    {
      title: 'Парковки',
      name: {
        type: UITableColumnCellType.Number,
        fieldName: 'parkingAmount',
      },
      type: TableColumnType.Basic,
    },
    {
      title: 'in /out (ср)',
      name: {
        type: UITableColumnCellType.Number,
        fieldName: 'averageIn',
      },
      subName: {
        type: UITableColumnCellType.Number,
        fieldName: 'averageOut',
      },
      type: TableColumnType.Basic,
    },
    {
      title: 'Длительность стоянки (ср)',
      name: {
        type: UITableColumnCellType.Number,
        fieldName: 'averageDurationInSecond',
      },
      width: '150px',
      type: TableColumnType.Basic,
    },
    {
      title: 'Мест',
      name: {
        type: UITableColumnCellType.Number,
        fieldName: 'placeAmount',
      },
      type: TableColumnType.Basic,
    },
    {
      title: 'Средняя нагрузка',
      type: TableColumnType.Custom,
      component: 'parking-load-difference-column',
      width: '150px',
    },
    // {
    //   type: TableColumnType.Custom,
    //   componentKey: 'parking-load-column',
    // },
    // {
    //   type: TableColumnType.Custom,
    //   componentKey: 'parking-load-chart-column',
    // },
  ],
};

export const parkingTableConfig: ITableConfig = {
  paginationType: 'client-side',
  columns: [
    {
      type: TableColumnType.Order,
      width: '70px',
    },
    {
      title: 'Название',
      name: {
        type: UITableColumnCellType.Text,
        fieldName: 'parking.title',
      },
      subName: {
        type: UITableColumnCellType.Text,
        fieldName: 'operator.title',
      },
      type: TableColumnType.Basic,
    },
    {
      title: 'in /out (ср)',
      name: {
        type: UITableColumnCellType.Number,
        fieldName: 'averageIn',
      },
      subName: {
        type: UITableColumnCellType.Number,
        fieldName: 'averageOut',
      },
      type: TableColumnType.Basic,
    },
    {
      title: 'Длительность стоянки (ср)',
      name: {
        type: UITableColumnCellType.Number,
        fieldName: 'averageDurationInSecond',
      },
      width: '150px',
      type: TableColumnType.Basic,
    },
    {
      title: 'Мест',
      name: {
        type: UITableColumnCellType.Text,
        fieldName: 'parking.placeAmount',
      },
      align: 'center',
      type: TableColumnType.Basic,
    },
    {
      title: 'Средняя нагрузка',
      type: TableColumnType.Custom,
      component: 'parking-load-difference-column',
      width: '150px',
    },
    // {
    //   type: TableColumnType.Custom,
    //   componentKey: 'parking-load-column',
    // },
    // {
    //   type: TableColumnType.Custom,
    //   componentKey: 'parking-load-chart-column',
    // },
  ],
};
